module.exports = __webpack_public_path__ + "img/case.c70e0862.png";